import S3PhotoModel from './S3PhotoModel';
import UserModel from './UserModel';
import LocationModel from './LocationModel';

export default class CounselorRequestModel {
  constructor(data) {
    if (!data) {
      data = {};
    }

    this.id = data.id || 0;
    this.first_name = data.first_name || '';
    this.last_name = data.last_name || '';
    this.email = data.email || '';
    this.on_campus_counselor = data.on_campus_counselor || false;

    this.recommendation_score = data.recommendation_score || 0;
    this.gender = data.gender || '';
    this.lgbtq = data.lgbtq || false;
    this.race = data.race || '';
    
    this.biography = data.biography || '';
    this.accepted_insurance = data.accepted_insurance || '';

    this.registered_in_states = (data.registered_in_states || []).map(s => new LocationModel(s));
    this.specialties = (data.specialties || []).map(s => new LocationModel(s));

    this.photo = data.photo ? new S3PhotoModel(data.photo) : null;
    this._photo = this.photo;

    if (data.user) {
      this.user = new UserModel(data.user);
      this.first_name = this.user.first_name;
      this.last_name = this.user.last_name;
      this.photo = this.user.photo;
    }

    this.cost = data.session_price || data.price || data.cost || 0;
    this.next_availability = data.next_availability ? new Date(data.next_availability) : null;

    if (!data.matched_preferences) {
      data.matched_preferences = {};
    }

    this.matched_preferences = {
      gender_preference_matched: data.matched_preferences.gender_preference_matched,
      lgbtq_preference_matched: data.matched_preferences.lgbtq_preference_matched,
      religion_preference_matched: data.matched_preferences.religion_preference_matched,
      language_preference_matched: data.matched_preferences.language_preference_matched,
      num_specialty_preferences: data.matched_preferences.num_specialty_preferences || 0,
      num_specialty_preferences_matched: data.matched_preferences.num_specialty_preferences_matched || 0,
    };
  }

  get fullName() {
    return this.name;
  }


  get name() {
    return `${this.first_name} ${this.last_name}`;
  }

  get has_specialties_match() {
    return this.matched_preferences.num_specialty_preferences_matched > 0;
  }
}
